import React from 'react';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';

interface NotificationProps {
  type: NotificationType;
  message: string;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({ type, message, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`notification ${type}`} role="alert">
      <p>{message}</p>
      <button
        onClick={onClose}
        className="notification-close"
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

export default Notification; 